// Bilingual dictionary for Prolancer / برولانسر
export const dict = {
  ar: {
    dir: "rtl",
    brand: "برولانسر",
    tagline: "حاسبة برولانسر للعمل الحر",
    langToggle: "EN",
    themeToggleDark: "الوضع الفاتح",
    themeToggleLight: "الوضع الداكن",
    integrate: {
      button: "أدوات التكامل",
      title: "أدوات التكامل والتصدير",
      subtitle: "أضف حاسبة برولانسر داخل موقعك أو استخدم API مباشرةً",
      tabEmbed: "تضمين iframe",
      tabApi: "REST API",
      tabLink: "رابط مباشر",
      embedDesc: "انسخ هذا الكود وألصقه في أي صفحة HTML — سيظهر بشكل حاسبة قابلة للتفاعل بدون ترويسة أو تذييل.",
      linkDesc: "شارك هذا الرابط في أي مكان لفتح الحاسبة كاملة:",
      apiDesc: "استدعِ نقاط النهاية مباشرةً من أي تطبيق. جميع النقاط تعيد JSON بترميز UTF-8.",
      copy: "نسخ",
      copied: "تم النسخ",
      widthLabel: "العرض",
      heightLabel: "الارتفاع",
      endpoints: "نقاط النهاية المتاحة",
      example: "مثال (curl)",
    },
    nav: {
      calculator: "الحاسبة",
      rates: "أسعار السوق",
      ai: "الذكاء الذكي",
      quotes: "العروض",
    },
    hero: {
      badge: "حاسبة برولانسر للعمل الحر · السوق السعودي 2026",
      title: "كم تسعّر خدمتك؟",
      subtitle:
        "احسب سعر مشروعك بالريال السعودي، ثم جهّز عرض سعر باسمك وبيانات عميلك، جاهزًا للإرسال والتوقيع.",
      cta: "ابدأ الحساب",
      freemium: "٣ اقتراحات أسعار مجانية شهريًا · مبنية على السوق السعودي + AI · باقات من ١٩ ر.س",
    },
    form: {
      serviceHeading: "١. اختر نوع الخدمة",
      experienceHeading: "٢. مستوى الخبرة",
      complexityHeading: "٣. مستوى تعقيد المشروع",
      scopeHeading: "٤. نطاق العمل",
      unit: "الوحدة",
      unitHour: "ساعة",
      unitDay: "يوم",
      unitProject: "مشروع كامل",
      quantity: "الكمية",
      revisions: "عدد التعديلات",
      rush: "تسليم عاجل (+٣٠٪)",
      description: "وصف المشروع (اختياري) — يُستخدم لاقتراح السعر بالذكاء الاصطناعي",
      descriptionPh: "مثال: تصميم هوية بصرية كاملة لمقهى فاخر في الرياض...",
    },
    experience: { beginner: "مبتدئ", intermediate: "متوسط", expert: "خبير" },
    complexity: { simple: "بسيط", medium: "متوسط", complex: "معقد" },
    summary: {
      title: "التسعير المقترح",
      rangeLabel: "نطاق السوق",
      min: "الحد الأدنى",
      avg: "المتوسط",
      max: "الحد الأعلى",
      breakdown: "تفاصيل الحساب",
      totalHours: "الساعات الكلية",
      subtotal: "المجموع الفرعي",
      currency: "ر.س",
      copy: "نسخ الملخص",
      copied: "تم النسخ ✓",
      print: "طباعة / PDF",
      save: "حفظ العرض",
      saved: "تم الحفظ ✓",
      whatsapp: "مشاركة واتساب",
    },
    ai: {
      title: "اقتراح سعر",
      subtitle: "اقتراح سعر بالذكاء الاصطناعي مبني على جدول أسعار مرجعي للسوق السعودي ووصف مشروعك — سعر تنافسي يساعدك على الفوز بالطلب على برولانسر.",
      button: "احسب الآن",
      loading: "جاري تحليل السوق السعودي...",
      recommended: "السعر الموصى به",
      winRate: "سعر الاختراق (يضمن الطلب)",
      confidence: "درجة الثقة",
      reasoning: "التحليل",
      tips: "نصائح للفوز بالمشروع",
      apply: "تطبيق السعر",
      options: "خيارات الأسعار",
      customize: "تعديل السعر يدويًا",
      finalPrice: "السعر النهائي",
      reset: "إعادة",
      quotaLeft: "اقتراحات الأسعار المتبقية هذا الشهر",
      quotaOf: "من",
      rateBlockedTitle: "تم بلوغ الحد الشهري",
      pricingHint: "٣ اقتراحات مجانية شهريًا · باقات من ١٩ ر.س",
      buyMore: "شراء",
    },
    rates: {
      title: "أسعار السوق المرجعية",
      desc: "هذه الأسعار الأساسية بالريال السعودي لكل ساعة عمل، مُستخلصة من متوسط السوق السعودي 2026 لكل فئة خدمة. الحاسبة تستخدمها لتحديد النطاق الأدنى والأعلى، والذكاء الاصطناعي يستند إليها لاقتراح سعرك النهائي.",
      howTo: "كيف تستفيد من هذا القسم؟",
      howToItems: [
        "افتح هذه اللوحة عندما تكون أسعار تخصصك أعلى أو أدنى من الافتراضي (مثلاً: مطوّر خبير في تقنية نادرة قد يبدأ من 200 ريال/ساعة بدلاً من 75).",
        "عدّل قيم (الأدنى / المتوسط / الأعلى) لأي خدمة تخصك — اضغط حفظ.",
        "الحاسبة تعيد الحساب فوراً بأسعارك الجديدة، والذكاء الاصطناعي يلتزم بها.",
        "الأسعار محفوظة في متصفحك فقط — لن تراها أي جهة أخرى.",
        "زر إعادة التعيين يُرجع كل شيء لأسعار السوق الافتراضية 2026.",
      ],
      unitLabel: "ريال / ساعة",
      minCol: "الأدنى",
      avgCol: "المتوسط",
      maxCol: "الأعلى",
      reset: "استعادة الافتراضي",
      save: "حفظ التعديلات",
    },
    quote: {
      client: "اسم العميل",
      clientPh: "أدخل اسم العميل...",
      quoteTitle: "عرض سعر",
      preparedFor: "مُقدّم إلى",
      date: "التاريخ",
      validity: "صالح لمدة ٧ أيام",
    },
    services: {
      graphic_design: "تصميم جرافيك",
      web_dev: "تطوير مواقع",
      app_dev: "تطوير تطبيقات",
      content_writing: "كتابة محتوى وترجمة",
      digital_marketing: "تسويق رقمي",
      ui_ux_design: "تصميم UI/UX",
      video_editing: "مونتاج وفيديو",
      seo_consulting: "استشارات SEO",
    },
    empty: "اختر خدمة لبدء الحساب",
  },
  en: {
    dir: "ltr",
    brand: "Prolancer",
    tagline: "Prolancer Freelance Calculator",
    langToggle: "ع",
    themeToggleDark: "Light mode",
    themeToggleLight: "Dark mode",
    nav: {
      calculator: "Calculator",
      rates: "Market rates",
      ai: "AI Assistant",
      quotes: "Quotes",
    },
    integrate: {
      button: "Integrations",
      title: "Integration & Export",
      subtitle: "Embed the Prolancer calculator anywhere or call the REST API directly",
      tabEmbed: "iframe Embed",
      tabApi: "REST API",
      tabLink: "Direct Link",
      embedDesc: "Copy this snippet into any HTML page — the calculator appears fully interactive with no header/footer.",
      linkDesc: "Share this URL anywhere to open the full calculator:",
      apiDesc: "Call the endpoints directly from any application. All endpoints return UTF-8 JSON.",
      copy: "Copy",
      copied: "Copied",
      widthLabel: "Width",
      heightLabel: "Height",
      endpoints: "Available endpoints",
      example: "Example (curl)",
    },
    hero: {
      badge: "Prolancer Freelance Calculator · Saudi market 2026",
      title: "How much should you charge?",
      subtitle:
        "Calculate your project price in SAR, then prepare a proposal with your name and your client's details — ready to send and sign.",
      cta: "Start calculating",
      freemium: "3 free price suggestions per month · based on Saudi market + AI · plans from 19 SAR",
    },
    form: {
      serviceHeading: "1. Choose service",
      experienceHeading: "2. Experience level",
      complexityHeading: "3. Project complexity",
      scopeHeading: "4. Scope of work",
      unit: "Unit",
      unitHour: "Hour",
      unitDay: "Day",
      unitProject: "Full project",
      quantity: "Quantity",
      revisions: "Revisions",
      rush: "Rush delivery (+30%)",
      description: "Project description (optional) — used by the AI price suggestion",
      descriptionPh: "e.g. Full brand identity for a premium Riyadh coffee shop...",
    },
    experience: { beginner: "Beginner", intermediate: "Intermediate", expert: "Expert" },
    complexity: { simple: "Simple", medium: "Medium", complex: "Complex" },
    summary: {
      title: "Recommended pricing",
      rangeLabel: "Market range",
      min: "Min",
      avg: "Avg",
      max: "Max",
      breakdown: "Breakdown",
      totalHours: "Total hours",
      subtotal: "Subtotal",
      currency: "SAR",
      copy: "Copy summary",
      copied: "Copied ✓",
      print: "Print / PDF",
      save: "Save quote",
      saved: "Saved ✓",
      whatsapp: "Share on WhatsApp",
    },
    ai: {
      title: "AI Price",
      subtitle: "AI price suggestion built on reference Saudi market rates and your project description — a competitive price that helps you win the order on Prolancer.",
      button: "Calculate now",
      loading: "Analyzing Saudi market...",
      recommended: "Recommended price",
      winRate: "Win-rate price (guarantees order)",
      confidence: "Confidence",
      reasoning: "Reasoning",
      tips: "Winning tips",
      apply: "Apply price",
      options: "Price options",
      customize: "Fine-tune price",
      finalPrice: "Final price",
      reset: "Reset",
      quotaLeft: "Price suggestions remaining this month",
      quotaOf: "of",
      rateBlockedTitle: "Monthly limit reached",
      pricingHint: "3 free/mo · from 19 SAR",
      buyMore: "Top up",
    },
    rates: {
      title: "Reference market rates",
      desc: "These SAR-per-hour baselines reflect the 2026 Saudi freelance market averages per service. The calculator derives the min–max range from them and the AI grounds every recommendation in them.",
      howTo: "How to use this panel",
      howToItems: [
        "Open it when your niche's real rates differ from the defaults (e.g. a senior specialist in a rare stack may start at 200 SAR/hour instead of 75).",
        "Edit the Min / Avg / Max values for any service that applies to you — hit Save.",
        "The calculator immediately re-computes and the AI honours your custom rates.",
        "Values are stored only in your browser — nobody else sees them.",
        "The Reset button restores the default 2026 reference rates.",
      ],
      unitLabel: "SAR / hour",
      minCol: "Min",
      avgCol: "Avg",
      maxCol: "Max",
      reset: "Reset defaults",
      save: "Save changes",
    },
    quote: {
      client: "Client name",
      clientPh: "Enter client name...",
      quoteTitle: "Quotation",
      preparedFor: "Prepared for",
      date: "Date",
      validity: "Valid for 7 days",
    },
    services: {
      graphic_design: "Graphic Design",
      web_dev: "Web Development",
      app_dev: "App Development",
      content_writing: "Content & Translation",
      digital_marketing: "Digital Marketing",
      ui_ux_design: "UI/UX Design",
      video_editing: "Video & Motion",
      seo_consulting: "SEO Consulting",
    },
    empty: "Pick a service to start",
  },
};

export const SERVICE_LIST = [
  { id: "graphic_design", icon: "Palette" },
  { id: "web_dev", icon: "Code2" },
  { id: "app_dev", icon: "Smartphone" },
  { id: "content_writing", icon: "PenLine" },
  { id: "digital_marketing", icon: "Megaphone" },
  { id: "ui_ux_design", icon: "LayoutGrid" },
  { id: "video_editing", icon: "Film" },
  { id: "seo_consulting", icon: "Search" },
];
